function SalientFeatures() {
  return (
    <section className="salient-features">
      <h2>Salient Features of the College</h2>

      <div className="features-container">

        <div className="feature-card">
          <h3>🎓 Government Scholarships</h3>
          <p>
            Government of India Scholarship Scheme for Backward Class (SC/ST) 
            and Minority students.
          </p>
        </div>

        <div className="feature-card">
          <h3>🏠 Student Support</h3>
          <p>
            Subsistence allowance under Dr. Babasaheb Ambedkar Swadhar Yojana 
            for rural students studying in urban areas.
          </p>
        </div>

        <div className="feature-card">
          <h3>📚 Smart Learning</h3>
          <p>
            Guidance through expert lectures using digital boards for better understanding.
          </p>
        </div>

        <div className="feature-card">
          <h3>🎯 Career Guidance</h3>
          <p>
            Free competitive exam guidance center with qualified and experienced faculty.
          </p>
        </div>

      </div>
    </section>
  );
}

export default SalientFeatures;